<template>
  <div class="upper-header">
    <div class="bar">
      <div class="container">
        <div class="site-logo">
          <router-link to="/"><img alt="Graphic Invention" src="../assets/logo-gi.svg"></router-link>
        </div>
        <div class="socials">
          <a href="https://nl.linkedin.com/company/graphic-invention/" target="_blank" rel="nofollow"><linkedin-icon/></a>
          <a href="https://nl-nl.facebook.com/graphicinvention/" target="_blank" rel="nofollow"><facebook-icon/></a>
          <a href="https://www.instagram.com/graphic_invention/" target="_blank" rel="nofollow"><instagram-icon/></a>
          <a href="https://twitter.com/gidemeern/" target="_blank" rel="nofollow"><twitter-icon/></a>
        </div>
      </div>
    </div>
    <transition name="vertical-slide">
      <vue-plyr v-if="$route.name == 'home'" :options="videoOptions" class="header-video" :ref="'videoHeader'" :style="'--height:' + videoHeight">
        <video src="../assets/header-video.mp4" autoplay playsinline>
          <source src="../assets/header-video.mp4" type="video/mp4">
        </video>
      </vue-plyr>
    </transition>
  </div>
</template>

<script>
// import { settings } from '../variables.js'

export default {
  data () {
    return {
      videoOptions: { controls: false, muted: true, autoplay: true, loop: { active: true } },
      videoHeight: '-700px'
    }
  },
  methods: {
    getVideoHeight () {
      if (document.querySelector('.header-video') !== null) {
        this.videoHeight = Math.ceil(document.getElementsByClassName('header-video')[0].getBoundingClientRect().height) * -1 + 'px'
      }
    }
  },
  mounted () {
    this.getVideoHeight()
  }
}
</script>

<style lang="scss">
  .upper-header {
    .bar {
      position: sticky;
      top: 0;
      padding: 10px 15px;
      z-index: 10;
      background-color: #86ff00;
    }
    .container {
      display: grid;
      grid-template-columns: minmax(200px, 300px) 1fr;
    }
    .site-logo {
      max-width: 175px;
      @media all and (min-width: 500px) {
        max-width: initial;
      }
    }
    .header-video {
      overflow: hidden;
      max-width: 100vw;
      // max-height: var(--height);
      max-height: 666px;
    }

    .socials {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      a {
        display: block;
        margin-left: 3px;
        text-decoration: none;
        color: #2c3e50;
        font-size: 22px;

        &:hover {
          color: #fff;
        }
      }
    }
  }

  .vertical-slide-enter-active, .vertical-slide-leave-active {
    transition: max-height .50s cubic-bezier(0.08, 0.69, 0.2, 0.99);
  }
  .vertical-slide-enter, .vertical-slide-leave-to {
    max-height: 0 !important;
  }
</style>
